<template>
    <div id="checkCode">
        <b-modal id="chkModal" @hide="onHide()" no-close-on-backdrop>
            <h4>{{$t('ENTER_CODE')}}</h4>
            <b-row class="text-center">
                <b-col>
                    <b-form-input
                        id="chkId"
                        v-model="$v.code.$model"
                        :state="validateState('code')"
                    ></b-form-input>
                </b-col>
                <b-col>
                    <b-button size="md" variant="success" @click="checkCode()">
                        {{$t('SEND')}}
                    </b-button>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{}">
                <b-button size="md" @click="resendCode()">
                    {{$t('RESEND_CODE')}}
                </b-button>
                <b-button size="md" variant="warning" @click="$bvModal.hide('chkModal')">
                    {{$t('CLOSE')}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BRow, BCol, BFormInput, BModal, BButton } from 'bootstrap-vue';
import { validationMixin } from "vuelidate";
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
    name: 'checkCode',
    components: {
        BRow, BCol, BFormInput, BModal, BButton
    },
    mixins: [validationMixin],
    props: {
        userName: String
    },
    data: function() {
        return {
            code: '',
            checked: false
        }
    },
    mounted() {
        this.$bvModal.show('chkModal');
    },
    methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    },
    async checkCode() {
        this.$v.$touch();
        if(this.$v.$anyError) return;
        try {
            await this.$http.get('/checkCode', {
                params: {
                    checkCode: this.code
                }
            });
            this.checked = true;
            this.onHide();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async resendCode() {
        try {
            await this.$http.get('resendCode');
            this.$showMsg(this.$t('DONE'));
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    onHide() {
        this.$emit('signIn', this.checked);
    }
  },
    validations: {
        code: {
            required,
            maxLength: maxLength(4)
        }
    }

}
</script>